import { render, staticRenderFns } from "./BlockListVideoCustom.vue?vue&type=template&id=1cb50dea&"
import script from "./BlockListVideoCustom.vue?vue&type=script&lang=js&"
export * from "./BlockListVideoCustom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports